export default angular
  .module("CodeSystemMetaCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("CodeSystemMetaController", [
    "$scope",
    "$rootScope",
    "CodeSystem",
    function (
      $scope,
      $rootScope,
      CodeSystem,
    ) {
      const codeSystemListener = $rootScope.$on("saveCodeSystemChanges", (e) => {
        e.stopPropagation();

        const isCodeSystemFieldModified = $rootScope.changedFields.get("codeSystem");

        const codeSystem = $scope.codeSystem;
        if (isCodeSystemFieldModified) {
          const allGroups = codeSystem.GROUPS.find(g => g.ID === -1);

          codeSystem.ALL_GROUPS = allGroups ? 1 : 0;
          codeSystem.GROUPS = allGroups
            ? codeSystem.GROUPS.filter(g => g.ID === -1)
            : codeSystem.GROUPS;

          CodeSystem.updateCodeSystem(codeSystem);
        }
      });
      $scope.$on("$destroy", codeSystemListener);
    },
  ]);
